/*
 * @Author: Yannis yannis2473@163.com
 * @Date: 2024-12-06 14:11:35
 * @LastEditors: yannis yannis2473@163.com
 * @LastEditTime: 2025-07-21 11:47:37
 * @FilePath: \crm-admin-vue\src\store\index.js
 * @Description: Do not edit
 * Copyright (c) 2025 by 久雀商业/Yannis, All Rights Reserved.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import permission from './modules/permission';
import app from './modules/app';
import crm from './modules/crm';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isMobile: false,
    windowWidth: 0,
    windowHeight: 0,
    mobileRatio: 1,
    lg: 1024,
    md: 768
  },
  modules: {
    app,
    permission,
    user,
    crm
  },
  getters,
  mutations: {
    SET_ISMOBILE: (state, val) => {
      state.isMobile = val;
    },
    SET_WINDOWWIDTH: (state, val) => {
      state.windowWidth = val;
      state.mobileRatio = val / 750;
    },
    SET_WINDOWHEIGHT: (state, val) => {
      state.windowHeight = val;
    }
  }
});

export default store;
